export const environment = {
  production: false,
  environmentName: 'development',
  msalConfig: {
    auth: {
      clientId: '2d000f55-fc43-419d-b686-c96b3dd1db22',
      authority:
        'https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1',
    },
  },
  apiConfig: {
    scopes: ['https://vcv-webapp-dev.azurewebsites.net/FrontEndSPA'],
    uri: '/api',
  },
  featureToggles: {
    enableKeyCreditMetrics: true,
    enableRefreshCompanyData: true,
    enableProjection: true,
    enableBankerIQ: true,
  },
};
